import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react'

const defaultValue: {
  modal: {children: ReactNode | null; setChildren: Function}
} = {
  modal: {children: null, setChildren: () => null},
}
export const ModalContext = createContext(defaultValue)

export const useModal = () => useContext(ModalContext).modal

export const ModalContextProvider = ({children}: {children: ReactNode}) => {
  defaultValue.modal.setChildren = useCallback((children: ReactNode | null) => {
    defaultValue.modal.children = children
    setValue({...defaultValue})
  }, [])

  const [value, setValue] = useState(defaultValue)

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}
